import { render, staticRenderFns } from "./RotateSquare.vue?vue&type=template&id=0005f9ca&scoped=true&"
import script from "./RotateSquare.vue?vue&type=script&lang=js&"
export * from "./RotateSquare.vue?vue&type=script&lang=js&"
import style0 from "./RotateSquare.vue?vue&type=style&index=0&id=0005f9ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005f9ca",
  null
  
)

export default component.exports